import React from 'react';


export default function Collections(props){
  return(null);
}
